import React, { useMemo } from 'react';
import { t } from '@sm/intl';
import { isEnterprisePackage } from '@sm/utils';
import { Grid } from '@wds/grid';
import { Box } from '@wds/box';

import MainHeading from '~pricing/components/MainHeading';
import Navigation from '~pricing/components/Navigation';
import HubSpotForm from '~pricing/components/HubSpotForm';
import { usePricingState } from '~shared/hooks/usePricingState';
import useTreatment from '~pricing/hooks/useTreatment';

import COPY from './copy';
import ContactUs from './ContactUs';

import useEnterprisePageStyles from './useStyles';

export default function EnterprisePage(): JSX.Element {
  const { HubSpotWrapper } = useEnterprisePageStyles();
  const {
    state: {
      packages: { userPackage },
    },
  } = usePricingState();

  const {
    uiExperiment: { configExperimentIdentifier, experimentComponent: ExperimentComponent },
  } = useTreatment();

  const isEnterpriseUser = useMemo(() => isEnterprisePackage(parseInt(userPackage?.id, 10)), [userPackage]);

  return (
    <div key="PricingEnterprise">
      <header>
        {configExperimentIdentifier === 'GROW_2911_TREATMENT' && ExperimentComponent && <ExperimentComponent />}
        <MainHeading>{t(isEnterpriseUser ? COPY.SURVEY_MONKEY_ENTERPRISE : COPY.MAIN_HEADING)}</MainHeading>
        {!isEnterpriseUser && <Navigation />}
      </header>
      <Box display="flex" flexJustify="center">
        <Grid pt={4} pb={5}>
          <Grid.Item xs={12} md={6} lg={6}>
            <ContactUs />
          </Grid.Item>
          <Grid.Item xs={12} md={5} lg={5}>
            <Box data-testid="Enterprise__HubSpotForm" className={HubSpotWrapper} p={4}>
              <HubSpotForm />
            </Box>
          </Grid.Item>
        </Grid>
      </Box>
    </div>
  );
}
